export const navLinks = [
  { navLinkId: 'Home', scrollToId: 'homeContainer' },
  { navLinkId: 'About', scrollToId: 'aboutContainer' },
  { navLinkId: 'Contact', scrollToId: 'contactContainer' },
];
